import React from "react";
import Layout from "@/components/Layout";
import ApplicationCalculators from "@/components/ApplicationCalculators";

export default function Applications() {
  return (
    <Layout>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-10" data-testid="page-applications">
        <div className="text-xs uppercase tracking-[0.2em] text-stone-500">Applications</div>
        <h1 className="text-3xl sm:text-4xl font-bold tracking-tight mt-1">Application calculators</h1>
        <p className="text-sm text-stone-600 mt-2 max-w-2xl">
          Every usage calculator in one place: meat and seafood, plant-based, snacks, liquids and more.
          Results are starting-point dosing math; confirm in bench trials against your own formula.
        </p>
        <div className="mt-6">
          <ApplicationCalculators productType="dry_blend" browseAll={true} />
        </div>
      </div>
    </Layout>
  );
}
